module.exports = __webpack_public_path__ + "img/search_bg.9faf626e.png";